module.exports = "/images/bq-sa.svg?f8d354d96d9b35935230e39de22ad3ef";